// extracted by mini-css-extract-plugin
module.exports = {"label":"accordion_label__R9T9v","label-text":"accordion_label-text__rZnrH","active":"accordion_active__wEaoh","content":"accordion_content__1kMqT"};